import type { ReactNode } from 'react';
import { AuroraBackground } from '../shared/AuroraBackground';

interface PageWrapperProps {
  children: ReactNode;
  className?: string;
  /** Forge temperature: 0 = cool steel, 1 = white-hot. Default 0. */
  warmth?: number;
}

export function PageWrapper({ children, className = '', warmth = 0 }: PageWrapperProps) {
  return (
    <div className={`relative min-h-screen bg-[#060A12] overflow-hidden ${className}`}>
      {/* GLSL aurora background with forge temperature */}
      <AuroraBackground warmth={warmth} />

      {/* Edge vignette + bottom fade */}
      <div className="absolute inset-0 pointer-events-none z-[1]">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_50%,rgba(6,10,18,0.6)_100%)]" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#060A12]/50" />
      </div>

      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
}
